import baseUrl from '@/api/baseUrl';
import store from '@/store';
import { onTokenExpired } from '@/util/authority';
import { isIntranet, isTestEnv } from '@/util/dev-tool';

// import LS from '@/util/ls';
import IAxios from './IAxios';
import { xToneRequestld } from './tools';

export const StatusCode = {
  success: 200, // success
  authExpired: 401, // OA auth is expired
};

const EppHeader = {
  eppGatewayCode: 'epp-gateway-code',
  eppGatewayMsg: 'epp-gateway-msg',
  successCode: '100000',
};

export const Errcode = {
  success: 0, // 成功
  tokenExpired: 999999, // token 过期
  repeatedName: 100506, // 名字重复
  batchReplaying: 151014, // 批量回复进行中
};

// const debugerData = LS.get('aisee-debuger-data');

// const getEnv = (path: string) => {
//   if (!debugerData || debugerData?.envList?.length === 0) {
//     return '2989dbfc';
//   }
//   const { envList } = debugerData;
//   for (const { envId, paths } of envList) {
//     if (paths?.includes(path)) {
//       return envId;
//     }
//   }
//   return '2989dbfc';
// };

const iAxios = new IAxios({
  baseURL: baseUrl.dcl,
  // baseURL: 'http://test.aisee.fb.woa.com',
  timeout: 60000,
  interceptors: {
    requestInterceptor: (config: any) => {
      config.withCredentials = true;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // add axios response code: 401
      config.validateStatus = (status: number) =>
        (status >= 200 && status < 300) || status === 401;
      // add token to header
      if (store?.userInfo?.token) {
        config.headers['X-Dcl-Token'] = store.userInfo.token;
      }
      // 测试环境绑定tapd时, 特殊处理
      if (isTestEnv() && config.url?.includes('/v1/tapd/auth/callback/test')) {
        // 连接后台特性环境时, 需要把 X-Dcl-Token 设置为空
        config.headers['X-Dcl-Token'] = '';
      }
      if (!isIntranet()) {
        // 外网添加防重放 Header
        config.headers['X-Tone-RequestId'] = xToneRequestld();
      }
      return config;
    },
    responseInterceptor: (response) => {
      const { data, headers, status } = response;
      const { rawResponseData } = response.config as typeof response.config & {
        rawResponseData?: boolean;
      };
      // check request code
      if (status === StatusCode.authExpired) {
        onTokenExpired();
        return;
      }
      // Token is expired
      const tokenError = data?.data?.errcode;
      if (tokenError && tokenError === Errcode.tokenExpired) {
        onTokenExpired();
        return;
      }
      // check geta way error code
      const eppGwCode = headers[EppHeader.eppGatewayCode];
      if (eppGwCode && eppGwCode !== EppHeader.successCode) {
        let gwMsg = headers[EppHeader.eppGatewayMsg];
        try {
          gwMsg = decodeURIComponent(gwMsg).replace(/\+/g, ' ');
        } catch (e) {
          console.log('decodeURIComponent error', e);
        }
        throw new Error(
          `gateway code not success, code: ${eppGwCode}, msg: ${gwMsg}`
        );
      }
      // check api error code
      const errcode = data?.errcode ?? data?.ErrCode;
      if (errcode && errcode !== Errcode.success) {
        const dataMsg = data?.msg ?? data?.Msg;
        throw new Error(
          `response code not success, code: ${errcode}, msg: ${dataMsg}`
        );
      }
      const repeatednameCode = data?.code;
      if (repeatednameCode && repeatednameCode === Errcode.repeatedName) {
        const dataMsg = data?.msg;
        throw new Error(
          `response code not success, code: ${repeatednameCode}, msg: ${dataMsg}`
        );
      }
      // response success return data
      return rawResponseData ? data : data.data ?? data.Data;
    },
  },
});

export default iAxios;
